/* eslint-disable */
import { StyleSheet } from 'react-native'
import { Colors, Metrics, Fonts } from '../../Themes/'

const containerCommons = {
  height: 64,
  justifyContent: 'center',
  alignItems: 'center',
}
const textCommons = {
  fontFamily: Fonts.style.font.light,
  fontSize: 17,
}
export default StyleSheet.create({
  containerSlider: {
    width: 190,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    backgroundColor: Fonts.style.color.success,
    ...containerCommons,
  },
  containerDisabled: {
    backgroundColor: '#4d4d4d',
    ...containerCommons,
  },
  slider: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  sliderText: {
    paddingLeft: 10,
    color: Fonts.style.color.white,
    ...textCommons,
  },
  sliderTextDisabled: {
    color: '#909090',
    ...textCommons,
  },
})
